var AddressBillingButtonView = (function (_baseView) {
    return _baseView.extend({
        el: '@addBillingAddress',

		events: {
			'click': '_open'
		},

		initialize: function () {
            _.bindAll(this, '_toggle', '_open');

            this.listenTo(this.model.currentBilling(), 'change', this._toggle);
            this.listenTo(this.model.deliveryModeSwitcher(), 'change', this._toggle);

		},

		_toggle: function() {

            var _deliveryModeSwitcher = this.model.deliveryModeSwitcher();
            var _address = this.model.currentBilling();

            var currentMode = _deliveryModeSwitcher.getMode();

            var display = !_address.get('ID') && currentMode === 1;

            this.$el.toggleClass('hidden-block', !display);
        },

        _open: function () {
            this.display('checkout.address.billing.form');
        }
    });
})(BaseView);
